export default "__VITE_ASSET__BwVssJqr__"